module.exports = __webpack_public_path__ + "_assets/img/people-icon.728fa656.svg";